import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 to-green-50 p-6" data-testid="error-boundary-fallback">
        <div className="max-w-sm w-full bg-white rounded-2xl shadow-xl p-6 text-center">
          <h2 className="text-xl font-bold text-slate-800 mb-2">Ops! Algo deu errado</h2>
          <p className="text-sm text-slate-600 mb-5">Tivemos um problema ao exibir esta tela. Toque abaixo para recarregar.</p>
          <button
            onClick={() => window.location.reload()}
            className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-3 rounded-xl transition-colors"
            data-testid="error-boundary-reload-btn"
          >
            Recarregar página
          </button>
          <button
            onClick={() => { window.location.href = '/'; }}
            className="w-full mt-2 text-emerald-700 font-medium py-2"
            data-testid="error-boundary-home-btn"
          >
            Voltar ao início
          </button>
        </div>
      </div>
    );
  }
}
